import { tenants } from "./Tenant.slice";

export const tenantActions = { ...tenants.actions };
